
export const isFunction = (value) => {
    return value && {}.toString.call(value) === '[object Function]';
}

export const isArray = (value) => {
    return Object.prototype.toString.call(value) == '[object Array]';
}

export const isString = (value) => {
    return Object.prototype.toString.call(value) === '[object String]';
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/class.helpers.ts